import * as React from "react";
const SvgViewArray = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M21 5h-3v14h3V5zm-4 0H7v14h10V5zM6 5H3v14h3V5z",
  fill: "currentColor"
}));
export default SvgViewArray;